<script setup>
import { useBg } from '@/stores/bgStore';
import { useIntersectionObserver } from '@vueuse/core';
import Pagination from '../Pagination.vue';
import ReviewCard from './Review/ReviewCard.vue';
import { ref } from 'vue';
const props = defineProps({
    reviews: Object,
});

const bg = useBg();
const target = ref(null);
useIntersectionObserver(target, ([{ isIntersecting }], observerElement) => {
    isIntersecting ? bg.add('review-overview') : bg.remove('review-overview');
});
</script>

<template>
    <div ref="target" class="container my-15 md:my-30">
        <div class="grid gap-8 md:gap-16 md:grid-cols-3">
            <ReviewCard v-for="review in reviews.data" :key="review.id" :review="review" />
        </div>

        <div class="flex justify-center mt-8 md:mt-16">
            <Pagination :links="reviews.links" />
        </div>
    </div>
</template>
